'use client';

import { DataTestIdEnum } from '@medprev-web-app/datatestid';

import { CartItemField } from './cart-item-field.component';

const STANDALONE_SCHEDULING_NOTICE
  = 'A data e o horário devem estar previamente confirmados com o profissional ou estabelecimento.';

export function CartItemStandaloneField() {
  return (
    <CartItemField
      label="Guia avulsa"
      value={<span>{STANDALONE_SCHEDULING_NOTICE}</span>}
      dataTestId={DataTestIdEnum.CART_ITEM_FIELD_STANDALONE}
    />
  );
}
